import React from "react";
import styles from "./Navbar.module.css";

import app_params from "../../config/params";

const Navbar = (props) => {
  return (
    <header>
      <nav className={`navbar navbar-expand-md navbar-light theme-navbar position-relative`}>
        <div className="container-fluid">
          <a className="navbar-brand" href={`${app_params.basepath}`}>
            <img
              src={`${app_params.basepath}/assets/logos/logofiusac.png`}
              alt="brand-logo"
              className="d-inline-block align-middle brand-logo"
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${styles.navbarCentered}`} id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 mx-lg-2 mt-3 mt-lg-0">
              <li className="nav-item mx-2 px-2 px-lg-0">
                <a
                  className="nav-link"
                  href="https://biblioteca.ingenieria.usac.edu.gt/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Página web biblioteca
                </a>
              </li>
              <li className="nav-item mx-2 px-2 px-lg-0">
                <a
                  className="nav-link"
                  href="https://biblioteca.usac.edu.gt/biblioteca2023/web/estudiante/login"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  e-books
                </a>
              </li>
              <li className="nav-item mx-2 px-2 px-lg-0">
                <a
                  className="nav-link"
                  href="/library/index.php?title=Especial:EstatusUsuario"
                >
                  Estatus Usuario
                </a>
              </li>
              <li className="nav-item mx-2 px-2 px-lg-0">
                <a className="nav-link" href="/api/charges/">
                  Solvencias
                </a>
              </li>
              <li className="nav-item mx-2 px-2 px-lg-0">
                <a
                  className="nav-link"
                  href="https://biblioteca.ingenieria.usac.edu.gt/index.php/informacion/redes-sociales-cientificas"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Redes sociales científicas
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
